<template>
  <div>
    <div class="textmobile-banner" style="display: block;">
      <van-image
        src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20220323/9uml3zu7c8c1xx1pvkqrx1mm.jpg"></van-image>
    </div>
    <div class="textmobile-content">
      <div id="test-editormd-view" class="markdown-body editormd-html-preview">
        <p>
          <a :href="wx_authorize_url">
            <van-image alt="" src="https://www.qr-batch.com/upload/1647593772guanying.png"></van-image>
          </a>
          <router-link :to="{ path: 'order-list' }">
            <van-image alt="" src="https://www.qr-batch.com/upload/1647593823dingdan.png"></van-image>
          </router-link>
          <router-link :to="{ path: 'user-cards' }">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20220322/x19wwckeqd5u35fj1pf7c1iu.png"></van-image>
          </router-link>
          <router-link :to="{ path: 'index' }">
            <van-image alt=""
              src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20220322/a9ouuu6ofz4h8z86biw8w6dh.png"></van-image>
          </router-link>

          <a :href="$wx_kefu_rc()">
            <van-image alt=""
              src="https://rc-admin-1259573531.cos.ap-chengdu.myqcloud.com/online-service.jpg"></van-image>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { $wx_authorize_url } from "@/util/wxSdk"
import { $wx_kefu_rc } from "@/util/wxSdk"

export default {
  name: "cxyq",

  data() {
    return {
      wx_authorize_url: $wx_authorize_url("https://" + location.host + "/movie/")
    }
  },

  methods: {
    $wx_kefu_rc: $wx_kefu_rc,

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  },

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.forbidBack, false);
      this.forbidBack()
    }
  },

  destroyed() {
    window.removeEventListener('popstate', this.forbidBack, false);
  },
}
</script>

<style scoped>
.textmobile-banner {
  display: none;
  width: 100%;
}

.textmobile-banner img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.textmobile-content {
  padding: 8px;
}

.editormd-preview-container,
.editormd-html-preview {
  width: auto;
}
</style>
